import type { IValuesPrac } from '../../../containers/NewPracLocation/valuesTypes';
import { allowedFileTypes } from '../../../tools/utils';

import classNames from 'classnames';

import { useFormikContext } from 'formik';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';


export const PracticalSitePlan = ({
    handler,
    editable = true,
}: {
    handler?: (step: number) => void;
    editable?: boolean;
}) => {
    const { values, errors, touched, submitCount } = useFormikContext<IValuesPrac>();

    const [isExpanded, setIsExpanded] = useState(false);
    const { t } = useTranslation();


    const isFormCompleted = useMemo(
        () => ['sitePlan'].every(field => !errors[field as keyof IValuesPrac] && touched[field as keyof IValuesPrac]),
        [errors, touched]
    );

    return (
        <div
            className={classNames('cco_collapse', {
                active: isExpanded,
            })}
        >
            <div className="cco_collapse_header">
                <div className="cco_text cco_text_3">
                    <div className="cco_text_inner">
                        <h3>3. {t('SummaryPracSite.PracticalTesting.PracticalTesting')}</h3>

                        <div
                            className={classNames({
                                success: isFormCompleted,
                                error: !isFormCompleted,
                            })}
                        >
                            {isFormCompleted
                                ? t('SummaryPracSite.PracticalTesting.com')
                                : submitCount < 1
                                ? t('SummaryPracSite.PracticalTesting.inprog')
                                : t('SummaryPracSite.PracticalTesting.note')}
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className="cco_collapse_toggle"
                    onClick={() => setIsExpanded(prevState => !prevState)}
                >
                    <span className="cco_collapse_toggle_text">{t('SummaryPracSite.PracticalTesting.View')}</span>
                </button>
            </div>

            <div className="cco_collapse_body">
                <div className="cco_collapse_body_inner">
                <p className="cco_text_1">{t('SummaryPracSite.PracticalTesting.pracArea')}</p>
                    <div className="cco_blurb cco_blurb_2">
                        <div className="cco_blurb_img">
                            {(values.sitePlan instanceof File && values.sitePlan.type.includes('image')) ||
                            ('string' === typeof values.sitePlan && values.sitePlan && !values.sitePlan.includes('.pdf')) ? (
                                <img
                                    onLoad={e => {
                                        const src = e.currentTarget.src;

                                        if (src.startsWith('blob:')) URL.revokeObjectURL(src);
                                    }}
                                    src={
                                        values.sitePlan instanceof File
                                            ? URL.createObjectURL(values.sitePlan)
                                            : values.sitePlan
                                    }
                                    alt="Site Plan"
                                />
                            ) : (
                               <span className="cco_blurb_img_icon cco_blurb_img_icon_file" />
                            )}
                        </div>

                        {values.sitePlan && (
                            <div className="cco_blurb_title">
                            {(values.sitePlan instanceof File && allowedFileTypes.includes(values.sitePlan.type)) ? values.sitePlan.name : null /* values.sitePlan */}
                            {(editable && !allowedFileTypes.includes(values.sitePlan.type))?(<p className='cco_blurb cco_blurb_error cco_blurb_3'>File type not supported.</p>):(null)}

                            </div>
                        )}
                    </div>

                    {editable && (
                        <div className="cco_btn cco_btn_2">
                            <a
                                href="#"
                                onClick={e => {
                                    handler?.(1);
                                    e.preventDefault();
                                }}
                            >
                                {t('SummaryPracSite.PracticalTesting.Edit')}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
